import { render, staticRenderFns } from "./PublicPostContent.vue?vue&type=template&id=ccde0c2c&scoped=true&"
import script from "./PublicPostContent.vue?vue&type=script&lang=js&"
export * from "./PublicPostContent.vue?vue&type=script&lang=js&"
import style0 from "./PublicPostContent.vue?vue&type=style&index=0&id=ccde0c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccde0c2c",
  null
  
)

export default component.exports